import { autoinject } from 'aurelia-framework';
import { FilterManager } from 'lib/tables/FilterManager';
import { Filters } from 'elements/Filter';
import { PubSub } from 'lib/event';
import { ServiceReportService } from 'services/service-report-service';
import { TableHeader } from 'components/table/table-content';
import { DialogService } from 'aurelia-dialog';
import { ServiceDialog } from 'components/service-dialog/service-dialog';
import { AsyncErrorHandler } from 'lib/ui';

type TrackingByProductionnrResult = {
  TypeName: string;
  ServiceId: number;
  NetId: number;
  NetIdentifier: string;
  Type: string;
  FieldName: string;
  ProductionNr: string;
};

@autoinject
export class ServiceTrackingProductionnrReport {
  protected tableHeaders: TableHeader<TrackingByProductionnrResult>[] = [
    { key: 'TypeName', label: 'general.name', sortable: false },
    { key: 'ServiceId', label: 'servicestation.serviceid', sortable: false },
    { key: 'NetIdentifier', label: 'general.NetId', sortable: false },
    { key: 'Type', label: 'general.type', sortable: false },
    { key: 'FieldName', label: 'general.field', sortable: false },
    { key: 'ProductionNr', label: 'general.productionNumber', sortable: false },
  ];

  protected tableData: TrackingByProductionnrResult[] = [];
  protected ready = true;
  protected exportProgress = false;

  constructor(
    protected fm: FilterManager,
    private pubsub: PubSub,
    private serviceReportService: ServiceReportService,
    private dialogService: DialogService
  ) {
    pubsub.sub('filter-manager:filter-changed', () => {
      this.getServiceTrackingByProductionnrReportData();
    });
  }

  protected async attached() {
    await this.getServiceTrackingByProductionnrReportData();

    this.fm.init({
      context: 'service-tracking-production-report',
      storageKey: 'service-tracking-production-report',
      filters: {} satisfies Filters,
      defaultFilters: {},
    });
  }

  protected async getServiceTrackingByProductionnrReportData() {
    this.ready = false;
    const response = await this.serviceReportService.getServiceTrackingByProductionnrReport(this.fm.queryFilter);
    this.fm.paginationTotalRecords = +response.headers.get('x-total-count') || 0;
    this.tableData = response.data;
    this.ready = true;
  }

  @AsyncErrorHandler
  async exportServiceTrackingProductionReport() {
    this.exportProgress = true;
    await this.serviceReportService.getServiceTrackingByProductionnrReportExport(this.fm.queryFilter);
    this.exportProgress = false;
  }

  protected openService(serviceId: number, netId: number) {
    this.dialogService
      .open({
        viewModel: ServiceDialog,
        model: { Id: serviceId, NetId: netId },
        lock: false,
        position: () => {},
      })
      .whenClosed(() => {
        document.querySelector('html').style.overflowY = null;
      })
      .catch(() => {
        document.querySelector('html').style.overflowY = null;
      });
  }

  protected detached() {
    this.pubsub.unsub();
  }

  protected unbind() {
    this.pubsub.unsub();
  }
}
